import { gateway } from "../../../gateway";

export const createVendor = async (token: string | null, payload: any) => {
  try {
    const res = await gateway.post(`/vendors`, payload, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
